import React, { useState } from 'react';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';
import Switch from '@mui/joy/Switch';

import EditIcon from '@mui/icons-material/Edit';

import { themeColors } from '../../styles/theme';
import SchemaEditorModal from './SchemaEditorModal';

export default function SchemaEditor({ schema, onChange }) {
  const [modalOpen, setModalOpen] = useState(false);
  const enabled = schema !== null && schema !== undefined;

  const fieldCount = enabled ? Object.keys(schema.properties || {}).length : 0;

  const handleToggle = (checked) => {
    if (checked) {
      onChange({ type: 'object', properties: {} });
    } else {
      onChange(null);
    }
  };

  return (
    <Box>
      {/* Enable/disable row */}
      <Box
        sx={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          p: 1.5,
          border: `1px solid ${themeColors.neutral[200]}`,
          borderRadius: enabled ? '8px 8px 0 0' : 1.5,
          borderBottom: enabled ? 'none' : `1px solid ${themeColors.neutral[200]}`,
          backgroundColor: enabled ? `${themeColors.primary[500]}08` : 'white',
          transition: 'all 0.15s ease',
        }}
      >
        <Box>
          <Typography level="body-sm" sx={{ fontSize: '0.8125rem', fontWeight: 500, color: themeColors.neutral[800] }}>
            Define output schema
          </Typography>
          {enabled && (
            <Typography level="body-xs" sx={{ fontSize: '0.6875rem', color: themeColors.neutral[500], mt: 0.25 }}>
              {fieldCount === 0 ? 'No fields defined' : `${fieldCount} field${fieldCount !== 1 ? 's' : ''}`}
              {schema?.title ? ` · ${schema.title}` : ''}
            </Typography>
          )}
        </Box>
        <Switch
          size="sm"
          checked={enabled}
          onChange={(e) => handleToggle(e.target.checked)}
          sx={{ '--Switch-trackWidth': '32px', '--Switch-trackHeight': '18px', '--Switch-thumbSize': '14px' }}
        />
      </Box>

      {/* Edit button (when enabled) */}
      {enabled && (
        <Button
          size="sm"
          variant="plain"
          startDecorator={<EditIcon sx={{ fontSize: 14 }} />}
          onClick={() => setModalOpen(true)}
          sx={{
            width: '100%',
            justifyContent: 'center',
            fontSize: '0.8125rem',
            fontWeight: 500,
            color: themeColors.primary[600],
            backgroundColor: `${themeColors.primary[500]}08`,
            border: `1px solid ${themeColors.neutral[200]}`,
            borderTop: 'none',
            borderRadius: '0 0 8px 8px',
            py: 0.875,
            '&:hover': {
              backgroundColor: `${themeColors.primary[500]}14`,
              color: themeColors.primary[700],
            },
            transition: 'all 0.15s ease',
          }}
        >
          Edit Schema
        </Button>
      )}

      <SchemaEditorModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        schema={schema}
        onSave={(newSchema) => {
          onChange(newSchema);
          setModalOpen(false);
        }}
      />
    </Box>
  );
}
